module.exports = __webpack_public_path__ + "static/photo-loek-cd8e56e4abf8bd69a1d6ae8cf42e5976.jpeg";